import { GrammarCheckAlert } from '../types';

const getUnderlineColor = (alert: GrammarCheckAlert): string => {
  if (
    alert?.category?.toLowerCase() === 'typography' ||
    alert?.category?.toLowerCase() === 'punctuation'
  ) {
    return '#d01cd0';
  }
  return '#f04438';
};

export default getUnderlineColor;
